module.exports = __webpack_public_path__ + "static/media/kevin-murphy-products.cce622ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/KevinMurphy/kevin-murphy-products.jpg
// module id = 32
// module chunks = 0